const Loader = (props) => {
    return (
        <div className="intra_header spinner-grow33">
        <div className="spinner-grow spinner-grow33" role="status"></div>
      </div>
    )
}
export default Loader;